import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { v4 } from "uuid";
import MainLayout from '../MainLayout';
import { setDocumentInformation, setIsExternal, setIsReadOnly, setUserInformation } from '../../app/EditorSlice';
import { padServices } from '../../api';
import Loader from '../SkeletonLoader/Loader';

const External = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const isVerified = useSelector((state) => state.editor.isExternal);

    useEffect(() => {
        (async () => {
            try {
                const result = await padServices.verifyExternal(id);
                dispatch(setIsExternal(true));
                dispatch(setIsReadOnly(true));
                dispatch(setUserInformation({
                    userId: `external-${v4()}`,
                    email: 'N/A',
                    name: 'External User'
                }));
                dispatch(setDocumentInformation(result?.data));
            } catch (error) {
                console.error("API error:", error);
                navigate('/unauthorized');
            } finally {
                setLoading(false);
            }
        })();
    }, [id]);

    return loading ? <Loader /> : isVerified ? <MainLayout /> : null;
};

export default External;
